import { css } from '@emotion/react'
import styled from '@emotion/styled'

import type { Props } from './SpeechBubble'

const S = {
  BubbleContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--Radius-300);
    text-align: left;
    white-space: nowrap;
    .bubble-content {
      position: relative;
      width: 100%;
    }
    .close-button-container {
      position: relative;
      width: 0px;
      margin-bottom: auto;
    }
    .close-button {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      padding: 12px 16px;
    }
  `,
  arrow: css`
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  `,
  arrowBorder: ({
    placement,
    arrowOffset = 0,
    borderColor,
    backgroundColor,
  }: {
    placement: Props['placement']
    arrowOffset?: number
    borderColor: string
    backgroundColor: string
  }) => {
    switch (placement) {
      case 'top':
      case 'top-right':
      case 'top-left': {
        const amount = {
          top: '-50%',
          'top-right': '700%',
          'top-left': '700%',
        }
        return css`
          left: 50%;
          bottom: -7px;
          border-width: 6px 6px 0;
          border-top-color: ${borderColor};
          transform: translateX(${amount[placement]});
          &:after {
            content: '';
            position: absolute;
            bottom: 1px;
            border-width: 6px 6px 0;
            border-color: transparent;
            border-top-color: ${backgroundColor};
            border-style: solid;
            transform: translateX(-50%);
            left: ${arrowOffset}px;
          }
        `
      }
      case 'left': {
        return css`
          top: 50%;
          transform: translateY(-50%);
          right: -6px;
          border-width: 6px 0 6px 6px;
          border-left-color: ${borderColor};
          &:after {
            content: '';
            position: absolute;
            right: 1px;
            border-width: 6px 0 6px 6px;
            border-color: transparent;
            border-left-color: ${backgroundColor};
            border-style: solid;
            transform: translateY(-50%);
          }
        `
      }
      case 'right': {
        return css`
          top: 50%;
          transform: translateY(-50%);
          left: -6px;
          border-width: 6px 6px 6px 0;
          border-right-color: ${borderColor};
          &:after {
            content: '';
            position: absolute;
            left: 1px;
            border-width: 6px 6px 6px 0;
            border-color: transparent;
            border-right-color: ${backgroundColor};
            border-style: solid;
            transform: translateY(-50%);
          }
        `
      }
      case 'bottom':
      case 'bottom-left': {
        const amount = {
          bottom: '-50%',
          'bottom-left': '-700%',
        }
        return css`
          top: -7px;
          left: 50%;
          transform: translateX(${amount[placement]});
          border-width: 0 6px 6px;
          border-bottom-color: ${borderColor};
          &:after {
            content: '';
            position: absolute;
            top: 1px;
            border-width: 0 6px 6px;
            border-color: transparent;
            border-bottom-color: ${backgroundColor};
            border-style: solid;
            transform: translateX(-50%);
            left: ${arrowOffset}px;
          }
        `
      }

      case 'bottom-right': {
        return css`
          top: -7px;
          right: ${arrowOffset}px;
          border-width: 0 6px 6px;
          border-bottom-color: ${borderColor};
          &:after {
            content: '';
            position: absolute;
            top: 1px;
            right: 0;
            border-width: 0 6px 6px;
            border-color: transparent;
            border-bottom-color: ${backgroundColor};
            border-style: solid;
            transform: translateX(50%);
          }
        `
      }
    }
  },
}

export default S
